import {
  WORKAREAS_CLEAR_ERROR,
  WORKAREAS_FETCH_FAIL,
  WORKAREAS_FETCH_REQUEST,
  WORKAREAS_FETCH_SUCCESS,
} from "../constants/WorkAreaConstants";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export const WorkAreaReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORKAREAS_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case WORKAREAS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload || [],
      };
    case WORKAREAS_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case WORKAREAS_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
